import { render, staticRenderFns } from "./InvoiceFabCard.vue?vue&type=template&id=24032c9c&scoped=true&"
import script from "./InvoiceFabCard.vue?vue&type=script&lang=js&"
export * from "./InvoiceFabCard.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceFabCard.vue?vue&type=style&index=0&id=24032c9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24032c9c",
  null
  
)

export default component.exports